import { render, staticRenderFns } from "./LoadingScreen.vue.js?vue&type=template&id=46b95ae2&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LoadingScreen.vue?vue&type=template&id=46b95ae2&scoped=true"
import script from "./LoadingScreen.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./LoadingScreen.vue.scss?vue&type=style&index=0&id=46b95ae2&prod&lang=scss&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LoadingScreen.vue?vue&type=style&index=0&id=46b95ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b95ae2",
  null
  
)

export default component.exports
component.options.__file = "src/components-v2/common/loading/LoadingScreen.vue"
